import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import pfmjLogo from '../../assets/pjmf__horizontal-white-transparent.svg';
import { landingTheme } from './theme';

export default function HeroBanner() {
  return (
    <Box
      id="home"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: landingTheme.gradients.hero,
        position: 'relative',
        overflow: 'hidden',
        pt: 10,
        pb: 8,
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center', color: 'white' }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
                fontWeight: 700,
                mb: 3,
                mt: { xs: 4, md: 16 },
                lineHeight: 1.2,
                fontFamily: landingTheme.fonts.heading,
              }}
            >
              Financial Due Diligence
              <br />
              <Box
                component="strong"
                sx={{ fontWeight: 800, color: landingTheme.colors.gold }}
              >
                Made Simple
              </Box>
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                mb: 4,
                maxWidth: '700px',
                mx: 'auto',
                opacity: 0.95,
                fontFamily: landingTheme.fonts.body,
              }}
            >
              AI-powered, fully customizable financial analysis for grantmakers.
              Streamline your due diligence process, save time, and make
              confident funding decisions.
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              href="/request-access"
              sx={{
                backgroundColor: landingTheme.colors.gold,
                color: landingTheme.colors.black,
                px: 4,
                py: 1.5,
                mb: { xs: 4, md: 16 },
                fontSize: '1.1rem',
                fontWeight: 600,
                borderRadius: '24px',
                '&:hover': {
                  backgroundColor: landingTheme.colors.accent,
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Get Started
            </Button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Box
              sx={{
                maxWidth: '900px',
                width: '100%',
                mx: 'auto',
                mb: 6,
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              }}
            >
              <Box
                component="iframe"
                src="https://www.youtube-nocookie.com/embed/5TRcRLUIegI?rel=0&modestbranding=1"
                title="Grant Guardian Overview"
                referrerPolicy="strict-origin-when-cross-origin"
                sx={{
                  width: '100%',
                  aspectRatio: '16 / 9',
                  border: 0,
                  display: 'block',
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </Box>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <Box
              component="img"
              src={pfmjLogo}
              alt="Patrick J. McGovern Foundation"
              sx={{
                width: '100%',
                maxWidth: '400px',
                height: 'auto',
                mx: 'auto',
                filter: 'brightness(0) invert(1)',
              }}
            />
          </motion.div>
        </Box>
      </Container>

      {/* Downward pointing shape divider */}
      <svg
        viewBox="0 0 1200 100"
        preserveAspectRatio="none"
        style={{
          position: 'absolute',
          bottom: -1,
          left: 0,
          width: '100%',
          height: '80px',
          display: 'block',
          backgroundColor: '#005974',
        }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon points="0,0 600,80 1200,0 1200,100 0,100" fill="#fafafa" />
      </svg>
    </Box>
  );
}
